import React from "react";

import CatchFormDetailsSection, {
  CatchFormDetailsAside,
} from "../../CreatePostModal/catch-form/CatchFormDetailsSection";
import { CatchFormLocationSection } from "../../CreatePostModal/catch-form/CatchFormMediaLocationSection";

export default function EditCatchPostForm({ catchForm, disabled }) {
  return (
    <div className="edit-post-catch-form">
      <div className="edit-post-form-section">
        <label className="edit-post-field edit-post-field-wide">
          <span>{catchForm.t("catch_caption")}:</span>
          <textarea
            value={catchForm.caption}
            onChange={(event) => catchForm.setCaption(event.target.value)}
            placeholder={catchForm.t("catch_caption_placeholder")}
            disabled={disabled}
            rows={4}
          />
        </label>
      </div>

      <div className="catch-form-grid edit-post-catch-grid">
        <div className="catch-form-left">
          <CatchFormLocationSection catchForm={catchForm} />

          <div className="edit-post-datetime-row">
            <label className="catch-form-field">
              <span>{catchForm.t("date")}:</span>
              <input
                type="date"
                value={catchForm.exifDate}
                onChange={catchForm.handleManualDateChange}
                disabled={disabled}
              />
            </label>

            <label className="catch-form-field">
              <span>{catchForm.t("time")}:</span>
              <input
                type="time"
                value={catchForm.exifTime}
                onChange={catchForm.handleManualTimeChange}
                disabled={disabled}
              />
            </label>
          </div>

          <CatchFormDetailsSection catchForm={catchForm} />
        </div>

        <CatchFormDetailsAside catchForm={catchForm} />
      </div>

      {catchForm.showFeedback && (
        <div className="edit-post-form-section">
          <label className="edit-post-field edit-post-field-wide">
            <span>{catchForm.t("catch_feedback")}:</span>
            <textarea
              value={catchForm.feedback}
              onChange={(event) => catchForm.setFeedback(event.target.value)}
              placeholder={catchForm.t("catch_feedback_placeholder")}
              disabled={disabled}
              rows={4}
            />
          </label>
        </div>
      )}
    </div>
  );
}
